<p class="snack-{{ data.type }}">{{ data.message }}</p>
